<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<mat-chip-listbox
	[hideSingleSelectionIndicator]="true"
	(change)="onSelectionChange($event)"
>
	@for (chip of chips; track $index) {
		<mat-chip-option
			[ngClass]="{ removable: removable }"
			[selected]="removable || chips[$index].selected"
			[selectable]="!removable && !chips[$index].selected"
		>
			{{ chip.label }}

			@if (removable) {
				<globalictcc-button
					[iconOnly]="true"
					iconName="close"
					(handleClick)="onRemoveChip($index)"
				/>
			}
		</mat-chip-option>
	}
</mat-chip-listbox>
